// frontend/src/utils/assessment.js
//
// Airbnb assesses Superhost quarterly, on 1 January / 1 April / 1 July /
// 1 October. This is the React-side copy of that logic.
//
// ⚠️ There are three other homes for it and they must agree:
//   - app/services/standing.py       next_assessment / days_until_assessment
//   - frontend/public/blog/rating-calculator.js   RC.nextAssessment
//   - frontend/public/airbnb-superhost-assessment-dates.html (inline, deliberate
//     duplication so the page works if the widget script fails)
// If the schedule ever changes, change all four.

const ASSESSMENT_MONTHS = [0, 3, 6, 9]; // Jan, Apr, Jul, Oct (0-indexed)

/** The next quarterly assessment date on or after `today`, as a UTC Date. */
export function nextAssessment(today = new Date()) {
  const year = today.getUTCFullYear();
  const start = Date.UTC(year, today.getUTCMonth(), today.getUTCDate());
  for (const month of ASSESSMENT_MONTHS) {
    const candidate = Date.UTC(year, month, 1);
    if (candidate >= start) return new Date(candidate);
  }
  return new Date(Date.UTC(year + 1, 0, 1));
}

/** Whole days from today until the next assessment. Zero on the day itself. */
export function daysUntilAssessment(today = new Date()) {
  const start = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
  return Math.round((nextAssessment(today).getTime() - start) / 86400000);
}

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** e.g. "1 October 2026" */
export function formatAssessment(date = nextAssessment()) {
  return `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
}
